import * as React from 'react';
import { useNavigate } from 'react-router-dom';

const CLIENT_ID = process.env.REACT_APP_OUTLOOK_CLIENT_ID;
const REDIRECT_URI = `${process.env.REACT_APP_URL}/oauth2callback-outlook`;
const SCOPE = ['https://graph.microsoft.com/Calendars.ReadWrite', 'https://graph.microsoft.com/User.Read', 'offline_access'].join(' ');

const OutlookOAuthRedirect: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const url =
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
      `client_id=${CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
      `&response_mode=query&scope=${encodeURIComponent(SCOPE)}&prompt=consent`;
    window.location.href = url;
  }, [navigate]);

  return <></>;
};

export default OutlookOAuthRedirect;
